module.exports = "/packs/images/svg/facilities/outdoor_climbing~ad1da24f7da22b726a51ae51e7729d9d.svg";